<template>
    <v-card-title class="subtitle-2 font-weight-bold grey--text text--darken-2">
        <v-row no-gutters align="center">
            <v-col class="text-truncate pr-3" v-bind="{ title }">{{ title }}</v-col>
            <v-col :cols="actionCols" class="my-n3">
                <slot name="actions" v-bind="{ title }" />
            </v-col>
        </v-row>
    </v-card-title>
</template>

<script>
export default {
    props: {
        title: { type: String },
        actionCols: { type: [String, Number], default: "auto" },
    },
};
</script>

<style>
</style>